import { useCallback } from 'react';
import { useAlert } from '@shared/components/Modal';
import { i18n } from '@shared/util/i18n';
import styles from './subtableRecurrence.module.css';

/**
 * Why a card being created can't take what was just tried: a repeating card can't have subtable
 * rows (adding a row), and a card with rows can't repeat (setting a repeat). A recurring create
 * makes several cards, and the rows would only go to one of them.
 */
export type SubtableRecurrenceConflict = 'addRow' | 'repeat';

/** Tells the user a card being created can't both repeat and have subtable rows. */
export function useSubtableRecurrenceAlert(): (
  conflict: SubtableRecurrenceConflict,
) => Promise<void> {
  const alert = useAlert();
  return useCallback(
    (conflict: SubtableRecurrenceConflict) => {
      if (conflict === 'addRow') {
        return alert({
          title: i18n('card.blocks.subtableInput.repeatingCardRowsTitle'),
          message: i18n('card.blocks.subtableInput.repeatingCardRowsMessage'),
          buttonLabel: i18n('common.ok'),
          className: styles.subtableRecurrenceAlert,
        });
      } else {
        return alert({
          title: i18n('card.blocks.subtableInput.cardWithRowsRepeatTitle'),
          message: i18n('card.blocks.subtableInput.cardWithRowsRepeatMessage'),
          buttonLabel: i18n('common.ok'),
          className: styles.subtableRecurrenceAlert,
        });
      }
    },
    [alert],
  );
}
